import SplashScreen from '@/components/splash-screen/splash-screen';

const Home = () => <SplashScreen />;

export default Home;
